import { Navigate, Route, Routes } from "react-router";

import { AdminRoute, FacilitatorRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { AlumniDirectoryPage } from "@/features/alumni";
import { FacilitatorModulePage } from "@/features/facilitator/module-page";
import { FacilitatorOverviewPage } from "@/features/facilitator/overview";
import { FacilitatorPlanningPage } from "@/features/facilitator/planning";
import { ForgotPasswordPage } from "@/features/forgot-password";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { ModuleCompanionPage } from "@/features/modules/module-page";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { ProgramOverviewPage } from "@/features/program/overview";
import { ResetPasswordPage } from "@/features/reset-password";
import { SignupPage } from "@/features/signup";
import { ToolRepositoryPage } from "@/features/tools";
import { VerifyEmailPage } from "@/features/verify-email";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/program" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/program" element={<ProgramOverviewPage />} />
      <Route path="/modules/:id" element={<ModuleCompanionPage />} />
      <Route path="/tools" element={<ToolRepositoryPage />} />
      <Route path="/alumni" element={<AlumniDirectoryPage />} />
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
      </Route>
      <Route element={<FacilitatorRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/facilitator" element={<FacilitatorOverviewPage />} />
        <Route path="/facilitator/modules/:id" element={<FacilitatorModulePage />} />
        <Route path="/facilitator/planning" element={<FacilitatorPlanningPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
